export const PRISMIC_DOCUMENT_TYPE = Object.freeze({
    LANDING: 'landing',
    CONTACTO: 'contacto'
});
